// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import Kyrgyzstan from '../_raw/flag/icon_flag_kyrgyzstan.png';

export default () => <img src={Kyrgyzstan} alt="Kyrgyzstan" />;
